import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import OnPageEditing from "components/OnPageEditing";

import css from "./VideoPlayer.module.scss";

const themes = {
    full: "-theme-full",
    default: "-theme-default"
};

class VideoPlayer extends React.PureComponent {
    static propTypes = {
        playing: PropTypes.bool.isRequired,
        onPlay: PropTypes.func.isRequired,
        onPageEditing: PropTypes.bool.isRequired,
        previewImage: PropTypes.string,
        previewImageMobile: PropTypes.string,
        youtubeVideoId: PropTypes.string,
        title: PropTypes.string,
        playVideoLabel: PropTypes.string.isRequired,
        theme: PropTypes.oneOf(Object.keys(themes).map(key => themes[key]))
    };

    static defaultProps = {
        theme: themes.default,
        onPageEditing: false
    };

    static themes = themes;

    state = {
        isPortrait: false
    }

    checkScreenOriantation = () => {
        if (typeof window !== "undefined") {
            this.setState({isPortrait: (window.innerHeight > window.innerWidth) && window.innerWidth < 560 ? true : false});
        }
    }

    componentDidMount = () => {
        this.checkScreenOriantation();
        window.addEventListener("resize", this.checkScreenOriantation);
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.checkScreenOriantation);
    }

    render() {
        const {
            previewImage,
            previewImageMobile,
            youtubeVideoId,
            onPlay,
            onPageEditing,
            playing,
            title,
            playVideoLabel,
            theme
        } = this.props;

        const poster = previewImageMobile && this.state.isPortrait ? previewImageMobile : previewImage ;

        return (
            <div
                className={cn(css.video, {
                    [css.playing]: playing,
                    [css[theme]]: theme
                })}
                style={
                    poster
                        ? {
                            backgroundImage: `url(${poster})`
                        }
                        : null
                }
            >
                <button
                    className={css.play}
                    onClick={onPlay}
                    type="button"
                >{`${playVideoLabel || ""} ${title}`}</button>
                <OnPageEditing active={onPageEditing} property="Title">
                    {title && <p className={css.title}>{title}</p>}
                </OnPageEditing>
                {playing && (
                    <iframe
                        allowFullScreen
                        className={css.iframe}
                        frameBorder="0"
                        src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&rel=0&showinfo=0`}
                    />
                )}
            </div>
        );
    }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.jsx